// CONTROLS
var AccessWidget = require("./controls/access.widget");
var DatePicker = require("./controls/datepicker");
var HomeSlick = require("./controls/homeslick");
var EventCalendar = require("./controls/eventCalendar");
var HerefordshireMap = require("./controls/herefordshire-map/map");
var GoTopButton = require("./controls/goTopButton");

// SERVICES
var EventBusService =  require("./services/eventBusService");
var SmartSuggestService = require("./services/smartSuggestService");
var HerefordshireMapService = require("./services/herefordshireMapService");
var VideoBoxComponent = require("./components/video-box/video-box.component");
var CookiesService = require("./services/cookies.service");

//COMPONENTS
var RecaptchaService = require("./components/recaptcha/recaptcha.service")
var CollapsiblePanelsService = require("./components/collapsible-panel/collapsible-panels.service");

function PcgFrontend() {
    this.init = function () {
        $.pcg = $.pcg || {};
        $.pcg.frontend = $.pcg.frontend || {};

        $.extend($.pcg.frontend, {
            accessWidget: new AccessWidget(),
            homeSlick: new HomeSlick(),
            datePicker: new DatePicker(),
            smartSuggest: new SmartSuggestService(),
            collapsiblePanelsService: new CollapsiblePanelsService(),
            eventCalendar: new EventCalendar(),
            eventBusService: new EventBusService(),
            herefordshireMap: new HerefordshireMap(),
            herefordshireMapService: new HerefordshireMapService(),
            goTopButton: new GoTopButton(),
            recaptchaService: new RecaptchaService(),
            videoBox: VideoBoxComponent,
            cookiesService: CookiesService
        });
    };
}

module.exports = new PcgFrontend();
